import {
  SHOW_CART,
  HIDE_CART,
  TOGGLE_CART_VISIBILITY
} from "../constants/actionTypes";

export const toggleCartVisibility = () => ({
  type: TOGGLE_CART_VISIBILITY
});

export const showCart = () => ({
  type: SHOW_CART,
  payload: true
});

export const hideCart = () => ({
  type: HIDE_CART,
  payload: false
});



// WEBPACK FOOTER //
// ./src/actions/cartActions.js